import { datePl, DEVICE_STATUSES, type DeviceStatus, type LateInspectionDto, PLAN_HEALTH, type PlanHealth, TICKET_STATUSES, type TicketStatus, todayInWarsaw } from '@bqcrm/shared';
import { Badge, Group, Text } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';

export const TICKET_COLORS: Record<TicketStatus, string> = {
  nowe: 'blue',
  do_umowienia: 'orange',
  zaplanowane: 'indigo',
  w_realizacji: 'yellow',
  wykonane: 'green',
  zamkniete: 'gray',
  anulowane: 'gray',
};

export const HEALTH_COLORS: Record<PlanHealth, string> = { w_terminie: 'green', do_umowienia: 'orange', po_terminie: 'yellow', zalegly: 'red', wstrzymany: 'gray' };

export const TicketBadge = ({ status }: { status: TicketStatus }) => (
  <Badge color={TICKET_COLORS[status]} variant="light">
    {TICKET_STATUSES[status]}
  </Badge>
);

export const HealthBadge = ({ health }: { health: PlanHealth }) => (
  <Badge color={HEALTH_COLORS[health]} variant={health === 'zalegly' ? 'filled' : 'light'}>
    {PLAN_HEALTH[health]}
  </Badge>
);

export const DeviceStatusBadge = ({ status }: { status: DeviceStatus }) => (
  <Badge color={status === 'czynne' ? 'green' : 'gray'} variant="light" size="sm">
    {DEVICE_STATUSES[status]}
  </Badge>
);

/** Ostrzeżenie przy planie przeglądów: zaległy przegląd grozi utratą gwarancji (lista przeglądów i karta urządzenia). */
export const WarrantyRisk = () => (
  <Group gap={4} wrap="nowrap" mt={2}>
    <IconAlertTriangle size={12} color="var(--mantine-color-red-6)" style={{ flexShrink: 0 }} />
    <Text size="xs" c="red">
      Ryzyko utraty gwarancji
    </Text>
  </Group>
);

/** Dzień „25.10.2026” — jak wszędzie (datePl). */
export const dateOnly = (d: string | null | undefined) => datePl(d);
/** Dzisiejsza data RRRR-MM-DD w czasie polskim. */
export const todayIso = () => todayInWarsaw();

/** QA6 P28: przeglądy wykonane po terminie i tolerancji — ślad przy planie (karta urządzenia, lista instalacji). */
export const LateInspections = ({ items, max = 3 }: { items: LateInspectionDto[]; max?: number }) =>
  items.length ? (
    <Group gap={4} wrap="nowrap" mt={2} align="flex-start">
      <IconAlertTriangle size={12} color="var(--mantine-color-orange-6)" style={{ flexShrink: 0, marginTop: 3 }} />
      <Text size="xs" c="orange.8">
        Przegląd po terminie:{' '}
        {items
          .slice(0, max)
          .map((l) => `${datePl(l.doneOn)} — ${l.daysLate} dni po terminie ${datePl(l.due)} (tolerancja ${l.toleranceDays} dni)`)
          .join('; ')}
        {items.length > max ? ` i ${items.length - max} wcześniej` : ''}
      </Text>
    </Group>
  ) : null;
